import { render } from "./index.vue?vue&type=template&id=48ab431c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=48ab431c&lang=scss&scoped=true"

import exportComponent from "/Users/wisdom/Documents/workspace/hoc-element-table/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.72.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ab431c"]])

export default __exports__